






















import { Vue, Component, Prop } from 'vue-property-decorator';
import { mdbRow, mdbCol, mdbInput, mdbSelect, mdbAlert, mdbIcon } from '@folky-tools/mdbvue';
import { PayPalPaymentConfig, PayPalEnvironmentType } from '@/models/common/paypal-payment-config';
import { requiredIf } from 'vuelidate/lib/validators';

@Component({
    components: {
        mdbRow,
        mdbCol,
        mdbInput,
        mdbSelect,
        mdbAlert,
        mdbIcon
    },
    validations: {
        payPalPaymentConfig: {
            clientId: {
                required: requiredIf(model => {
                    return model.allowPayPalPayments;
                })
            }
        }
    }
})
export default class EditPayPalPaymentConfig extends Vue {
    @Prop(PayPalPaymentConfig)
    private payPalPaymentConfig!: PayPalPaymentConfig;
    private environments: any[] = [];

    private mounted(): void {
        for (const n in PayPalEnvironmentType) {
            if (typeof PayPalEnvironmentType[n] === 'number') {
                this.environments.push({
                    value: PayPalEnvironmentType[n],
                    text: this.$i18n.t(`components.businesses.editPayPalPaymentConfig.payPalEnvironment.${n.toString()}`),
                    selected: n === PayPalEnvironmentType[this.payPalPaymentConfig.environment!]
                });
            }
        }

        if (!this.payPalPaymentConfig.environment) {
            this.environments[1].selected = true;
        }
    }

    private onChangeEnvironment(value: PayPalEnvironmentType, text: string) {
        this.payPalPaymentConfig.environment = value;
    }

    private hasErrors(): boolean {
        this.$v.payPalPaymentConfig.$touch();
        if (this.$v.payPalPaymentConfig.$error) {
            return true;
        }
        return false;
    }
}
